import { NAME } from './constants';

export default {
  START: `${NAME}/START`,
  STARTED: `${NAME}/STARTED`,
  STARTING: `${NAME}/STARTING`,
  CREATE_MW: `${NAME}/CREATE_MW`,
  CREATING_MW: `${NAME}/CREATING_MW`,
  CREATED_MW: `${NAME}/CREATED_MW`,
  FAILED_TO_CREATE_MW: `${NAME}/FAILED_TO_CREATE_MW`,
};
